<template>
  <div class="customer-manage">
    <div class="app-panel">
      <p>
        <span>性别：</span>
        <span v-for="(value, index) in sexDatas" :key="index" class="item" :class="{active: sexValue === value.value}" @click="changeSex(value.value)">{{value.text}}</span>
      </p>
      <p>
        <span>年龄：</span>
        <span v-for="(value, index) in ageDatas" :key="index" class="item" :class="{active: ageValue === value.value}" @click="changeAge(value.value)">{{value.text}}</span>
      </p>
    </div>
    <div v-loading="loading">
      <template v-if="page.total">
        <div class="el-table">
          <div class="item" @click="scan(value.customer_id)" v-for="(value, index) in datas" :key="index">
            <el-image :src="value.face_data[0].attachment_data.attachment_access_url"></el-image>
            <p class="number">{{value.project_customer_open_id}}</p>
            <el-tag size="small" v-if="value.attr_data.project_customer_attr_gender === 1">男</el-tag>
            <el-tag size="small" type="danger" v-else>女</el-tag>
            <el-tag type="warning" size="small">{{value.attr_data.project_customer_attr_age}}岁</el-tag>
            <p class="text">首次抓拍时间<br>{{value.first_recognition_at}}</p>
          </div>
        </div>
        <el-pagination :total="page.total" :page-size="page.pageSize" :current-page="page.currentPage" @current-change="currentChange" background></el-pagination>
      </template>
      <div class="empty" v-else><i class="el-icon-warning"></i>暂无数据</div>
    </div>
    <el-drawer :title="dialog.title" :visible.sync="dialog.show" center size="80%" append-to-body>
      <customer-info :id="dialog.id" v-if="dialog.show"></customer-info>
    </el-drawer>
  </div>
</template>

<script>
  import CustomerService from '@/io/customer.js';
  import CustomerInfo from '@/views/CustomerInfo.vue';

  export default {
    name: 'CustomerManage',
    data() {
      return {
        loading: false,
        sexDatas: [
          {
            text: '全部',
            value: ''
          }
        ],
        sexValue: '',
        ageDatas: [
          {
            text: '全部',
            value: '-'
          }
        ],
        ageValue: '-',
        datas: [],
        page: {
          pageSize: 0,
          total: 0,
          currentPage: 1
        },
        dialog: {
          title: '客户详情',
          show: false,
          id: null
        }
      }
    },
    components: {
      CustomerInfo,
    },
    mounted () {
      this.initType().then(res => {
        this.initDatas();
      }).catch(() => {});
    },
    methods: {
      initType() {
        return CustomerService.paramInfo().then(res => {
          this.sexDatas = this.sexDatas.concat(res.data.gender);
          this.ageDatas = this.ageDatas.concat(res.data.age.map(val => {
            return {
              text: val.text,
              value: `${val.range.min}-${val.range.max}`
            };
          }));
        }).catch(() => {});
      },
      initDatas() {
        this.loading = true;
        CustomerService.listPage(
          this.sexValue,
          this.ageValue.split('-')[0],
          this.ageValue.split('-')[1],
          null,
          null,
          this.page.currentPage
        ).then(res => {
          let datas = [];
          res.data.data.forEach(val => {
            if (val.face_data.length) { 
              datas.push(val);
            }
          });
          this.datas = datas;
          this.page.pageSize = res.data.per_page;
          this.page.total = res.data.total;
        }).catch(() => {}).finally(() => {
          this.loading = false;
        });
      },
      changeSex(value) {
        this.sexValue = value;
        this.page.currentPage = 1;
        this.initDatas();
      },
      changeAge(value) {
        this.ageValue = value;
        this.page.currentPage = 1;
        this.initDatas();
      },
      currentChange(page) {
        this.page.currentPage = page;
        this.initDatas();
      },
      scan(id) {
        this.dialog.show = true;
        this.dialog.id = id * 1;
      }
    }
  }
</script>

<style lang="less" scoped>
  @import '../assets/styles/tools.less';
  .customer-manage {
    .app-panel {
      padding: 5px 20px;
      margin-bottom: 10px;
      & > p {
        display: flex;
        font-size: 14px;
        margin: 15px 0;
        span {
          min-width: 55px;
          padding: 6px 0;
          border-radius: 4px;
          text-align: center;
          transition: all @time;
          & + span {
            margin-left: 10px;
          }
          &.item {
            cursor: pointer;
            &:hover,
            &.active {
              background-color: @color-primary;
              color: @color-white;
            }
          }
        }
      }
    }
    .el-table {
      display: flex;
      flex-wrap: wrap;
      background-color: initial;
      &::before {
        height: 0;
      }
      .item {
        background-color: @color-white;
        padding: @distance;
        text-align: center;
        width: calc(20% - 56px);
        transition: all @time;
        cursor: pointer;
        margin: 10px 0 10px 20px;
        &:nth-of-type(5n+1) {
          margin-left: 0;
        }
        &:hover {
          box-shadow: @box-shadow-1;
        }
        .el-image {
          width: 90px;
          height: 90px;
          border-radius: 50%;
          margin: 0 auto;
        }
        .number {
          font-size: 16px;
          font-weight: bold;
          margin: 10px 0;
          .text-overflow;
        }
        .el-tag {
          min-width: 45px;
        }
        .text {
          margin-top: 20px;
          font-weight: bold;
          color: @color-text-3;
          line-height: 24px;
        }
      }
    }
    .el-pagination {
      padding: @distance;
      background-color: @color-white;
      margin-top: 10px;
    }
    .empty {
      opacity: .5;
      display: flex;
      flex-direction: column;
      align-items: center;
      i {
        font-size: 24px;
        margin-bottom: 5px;
      }
    }
  }
  /deep/ .el-drawer {
    .el-drawer__body {
      background-color: @color-1;
      padding: @distance;
    }
  }
</style>